import type { Student } from '~pages/payments/bulk-charge-students';

import { ScrollArea } from '~shared/shadcn/ui/scroll-area';

interface ConfirmationStepProps {
  students: Array<Student>;
}

export function ConfirmationStep({ students }: ConfirmationStepProps) {
  return (
    <div className='space-y-6'>
      <div className='rounded-lg border bg-card p-4'>
        <h3 className='mb-2 text-lg font-semibold'>Review Selected Students</h3>
        <p className='mb-4 text-sm text-muted-foreground'>
          You are about to charge {students.length} student
          {students.length !== 1 ? 's' : ''}. Please review the list below and
          confirm to proceed.
        </p>

        <ScrollArea className='h-[350px]'>
          <div className='space-y-1'>
            {students.map((student) => (
              <div
                key={student._id}
                className='flex items-center rounded-md px-2 py-1.5 hover:bg-muted'
              >
                <div className='flex-1'>
                  <p className='text-sm font-medium leading-none'>
                    {student.name}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </ScrollArea>
      </div>
    </div>
  );
}
